var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1617,
    viewBox: "0 0 1440 1617",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "#FFFDFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 625C0 625 214.109 661.773 287.5 684C360.891 706.227 581.672 576.263 735.5 625C889.328 673.738 971 711 1083 684C1195 657 1440 625 1440 625V1586H0V625Z",
    fill: "#030115",
    fillOpacity: 0.04
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 655.025C0 655.025 214.109 691.798 287.5 714.025C360.891 736.252 581.672 606.287 735.5 655.025C889.328 703.763 971 741.025 1083 714.025C1195 687.025 1440 655.025 1440 655.025V1616.02H0V655.025Z",
    fill: "#030115"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1445 604C1445 762.534 1445 829.5 1445 987C1418.31 1017.84 1399.5 987 1306.5 948C1094.91 948 1234.97 877.402 1134.43 753.778C1083.46 691.097 890 587.663 890 509.534C890 374.932 1030.93 379.483 1166.04 302.522C1264.03 246.706 1236.39 97 1370.44 97C1409.78 97 1424 113.78 1445 125.5C1424 261.78 1445 400.432 1445 604Z",
    fill: "#E4F0FC",
    fillOpacity: 0.17
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.65b8845a8bad6843e856e5b76ed60d56.svg";
export { ForwardRef as ReactComponent };